import React from "react";
import { useFormik } from "formik";
import PropTypes from "prop-types";
import TextField from "@material-ui/core/TextField";
import * as Yup from "yup";

import Button from "../../components/button";

const CreateFaqForm = props => {
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      question: "",
      answer: ""
    },
    validationSchema: Yup.object({
      question: Yup.string()
        .min(4, "Question must be of minimum length 4")
        .required("Please enter question"),
      answer: Yup.string()
        .min(2, "Answer must be of minimum length 2")
        .required("Please enter answer")
    }),
    onSubmit: values => {
      props.onFormSubmit(values);
    }
  });

  return (
    <form className="d-flex flex-column" onSubmit={formik.handleSubmit}>
      <p>Question </p>
      <TextField
        name="question"
        className="w-100"
        rows="4"
        multiline
        label="Enter question"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values.question}
        error={formik.touched.question && formik.errors.question ? true : false}
        helperText={
          formik.touched.question && formik.errors.question
            ? formik.errors.question
            : ""
        }
      />
      <br />
      <p>Answer</p>
      <TextField
        name="answer"
        className="w-100"
        rows="5"
        multiline
        label="Enter answer"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values.answer}
        error={formik.touched.answer && formik.errors.answer ? true : false}
        helperText={
          formik.touched.answer && formik.errors.answer
            ? formik.errors.answer
            : ""
        }
      />
      <br />
      <p className="mb-0 d-flex justify-content-center">
        <Button title="Submit" type="submit" />
      </p>
    </form>
  );
};

export default CreateFaqForm;

CreateFaqForm.defaultProps = {
  onFormSubmit: () => {}
};

CreateFaqForm.propTypes = {
  onFormSubmit: PropTypes.func
};
